import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';

import * as olci from '../../../actions/olci';
import * as fromRoot from '../../../reducers';
import { BrowserUtils } from 'src/app/utils/browser.utils';
import { AnalyticsData } from 'src/app/models/analytics-data';
import { MobileAppLinks } from 'src/app/models/mobile-app-links';
import { CONSTANTS, analyticsConstants } from '../../../constants';
import { BookingService } from '../../core/services/booking.service';
import {AnalyticsDataParamsInterface} from '../../../effects/interfaces';
import { AnalyticsService } from '../../core/services/analytics.services';
import {TrackFrontendDeepLinkEventAction} from '../../../actions/tracking';

@Component({
    selector: 'app-vaccination-reminder',
    templateUrl: './modal-vaccination-reminder.component.html',
    styleUrls: ['./modal-vaccination-reminder.component.scss'],
    standalone: false
})
export class ModalVaccinationReminderComponent implements OnInit, OnChanges {
	@Input() public bundle: any = null;
	@Input() public layoutState: string;

	brandName: string;
	mobileAppLinks: MobileAppLinks = { ios: '', android: '', unified: '' };
	mobileAppLinksPayload: AnalyticsData | null;
	device: string;
	isAppleDevice: boolean;
	isAndroidDevice: boolean;
	showModal = false;

	constructor(
		@Inject(CONSTANTS) public constants: any,
		private readonly store: Store<fromRoot.AppState>,
		private readonly bookingService: BookingService,
		private browserUtils: BrowserUtils,
		private analyticsService: AnalyticsService,
		@Inject('UrlService') public urlService: any
	) {}

	ngOnInit() {
		this.brandName = this.bookingService.getBrand();

		this.device = this.browserUtils.getDevice();
		this.isAppleDevice = this.device === this.constants.DEVICE_TYPE.IPHONE || this.device === this.constants.DEVICE_TYPE.IPAD;
		this.isAndroidDevice = this.device === this.constants.DEVICE_TYPE.ANDROID;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes['layoutState'] || !changes['layoutState'].currentValue) return;

		if (changes['layoutState'].currentValue.openedModalName === this.constants.MODAL.VACCINATION_REMINDER) {
			this.initMobileAppLinks();
			this.showModal = true;
		} else {
			this.showModal = false;
		}
	}

	private initMobileAppLinks() {
		this.mobileAppLinksPayload = this.analyticsService.getAnalyticsDataForTracking(
			this.constants.APP_STORE_SOURCE_PAGE.MOBILE_AD_MODAL,
			this.constants.ANALYTICS_LOCATIONS.BOARDING_PASS
		);
		this.mobileAppLinks = this.urlService.mobileAppLinks(this.mobileAppLinksPayload);
	}

	trackDeepLink(deviceStore: string) {
		const analyticsData: AnalyticsDataParamsInterface = {
			event: analyticsConstants.INTERACTION_EVENT_TYPE,
			interaction: `boardingpass:${deviceStore}`,
			sourcePage: this.constants.APP_STORE_SOURCE_PAGE.MOBILE_AD_MODAL,
			ctaLocation: this.constants.ANALYTICS_LOCATIONS.BOARDING_PASS
		};
    this.store.dispatch(new TrackFrontendDeepLinkEventAction(analyticsData));
	}

	public closeModal(): void {
		this.store.dispatch(new olci.CloseModalAction());
	}
}
